import { Trans } from '@lingui/react/macro';

import { BaseModal } from '@/components/ui/base-modal';
import type { ShiftSet } from '@/types/template';

import { PatternStarterChoices } from './pattern-starters';

interface AddPatternModalProps {
  /** Whether the modal is shown. */
  open: boolean;
  /** Begin a new pattern from a starter skeleton, or `null` to start from scratch. */
  onStart: (pattern: ShiftSet | null) => void;
  /** Opens the bulk Excel import. */
  onImport: () => void;
  /** Dismiss the modal without choosing. */
  onClose: () => void;
}

/**
 * "Add pattern" chooser shown once a template already has patterns: the same
 * starter / start-from-scratch / import choices as the empty pane, in a modal,
 * so adding a further pattern isn't limited to building from scratch.
 */
export function AddPatternModal({ open, onStart, onImport, onClose }: AddPatternModalProps) {
  return (
    <BaseModal
      open={open}
      onOpenChange={(next) => {
        if (!next) onClose();
      }}
      title={<Trans>Add a shift pattern</Trans>}
      description={<Trans>Start from a common pattern or build your own.</Trans>}
      className="sm:max-w-lg"
    >
      <PatternStarterChoices onStart={onStart} onImport={onImport} />
    </BaseModal>
  );
}
